import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { connect } from "react-redux";

import Login from "../containers/Pages/Login/NewUserLogin";
import CETDashboardContainers from "../containers/CETDashBoard";
import PartnerDashBoardContainers from "../containers/PartnerDashBoard-CT";
import LeadManagementDashboard from "../components/LeadManagementDashboard/LeadManagementDashboard";
import RMDashboardContainers from "../containers/RMDashboard";
import { getPartnerSidebar } from "../redux/PartnerSidebar/PartnerSidebarAction";
import DashBoard from "../components/DashBoard/DashBoard";
import PayoutMakerDashboardContainers from "../containers/PayoutMakerDashBoard";
import PayoutCheckerDashboardContainers from "../containers/PayoutCheckerDashBoard";
import PayoutCPCheckerDashboardContainers from "../containers/PayoutCPCheckerDashBoard";
import { useLocation } from "react-router-dom";
import { initGA, trackPageview, trackEvent } from "../ga/index";
import { useSelector } from "react-redux";

// const PartnerDashBoardContainers = React.lazy(() =>
//   import("../containers/PartnerDashBoard-CT")
// );

// const CETDashboardContainers = React.lazy(() =>
//   import("../containers/CETDashBoard")
// );

const RestrictedRoutes = (props) => {
  const { idToken, userData } = props.state.auth;

  const loggedInRoleType = userData?.loggedInRoleType;

  const partnerFirmID = useSelector(
    (state) => state?.auth?.checkLogin?.partnerFirmDetails?.partnerFirmId
  );

  useEffect(() => {
    if (props.firmId && props.access_token) {
      props.getPartnerSidebar({
        accessToken: props.access_token,
        partnerFirmId: props?.firmId,
      });
    }
  }, [props.firmId, props.access_token]);

  const partnerSidebarDtoList =
    props?.partnerSidebarDtoList?.length > 0
      ? props?.partnerSidebarDtoList
      : [];

  const FirmDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "FirmDetails")
      ?.status === "COMPLETE"
      ? true
      : false;

  const verificationStatus =
    props.partnerFirmDetails?.partnerFirmStatus === "FOR_VERIFICATION" ||
    props.partnerFirmDetails?.partnerFirmStatus === "ESIGN_PENDING" ||
    props.partnerFirmDetails?.partnerFirmStatus === "APPROVED"
      ? true
      : false;

  const CETRoutes = [
    {
      path: "CETDashboard/*",
      element: <CETDashboardContainers />,
    },
    {
      path: "PartnerDashBoard/*",
      element: <PartnerDashBoardContainers />,
    },
  ];

  const RMRoutes = [
    {
      path: "RMDashboard/*",
      element: <RMDashboardContainers />,
    },
    {
      path: "PartnerDashBoard/*",
      element: <PartnerDashBoardContainers />,
    },
  ];

  const PartnerRoutes = [
    {
      path: "PartnerDashBoard/*",
      element: <PartnerDashBoardContainers />,
      active: !verificationStatus,
    },

    {
      path: "/leadManagementDashboard/*",
      element: <LeadManagementDashboard />,
      // active: FirmDetailStatus || verificationStatus,
      active: true,
    },
    {
      path: "/dashBoard",
      element: <DashBoard />,
      active: true,
    },
  ];

  const PayoutMakerRoutes = [
    {
      path: "PayoutMakerDashBoard/*",
      element: <PayoutMakerDashboardContainers />
    }
    
  ];

  const PayoutCheckerRoutes =[
    {
      path: "PayoutCheckerDashBoard/*",
      element: <PayoutCheckerDashboardContainers />
    }
  ]

  const PayoutCPCheckerRoutes = [
    {
      path:"PayoutCPCheckerDashboard/*",
      element: <PayoutCPCheckerDashboardContainers />
    }
  ]

  const location = useLocation();

  useEffect(() => {
    initGA(partnerFirmID);
  }, [partnerFirmID]);

  useEffect(() => {
    const isLogin = location.pathname === "/";
    const path = isLogin ? "/login" : location.pathname;
    const title = path || "Unknown Page";

    document.title = title;

    // if (partnerFirmID) {
    // const pathName = `${path}-${partnerFirmID}`;
    const pathName = `${path}`;
    trackPageview(pathName);
    // }

    trackEvent(title, partnerFirmID, "", {
      label: title,
      category: title,
      action: title,
    });
  }, [location, partnerFirmID]);

  if (idToken && loggedInRoleType === "CET") {
    return (
      <Routes>
        <Route
          path="*"
          element={<Navigate to="/CETDashboard/PartnerManagement" replace />}
        />
        {CETRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    );
  } else if (idToken && loggedInRoleType === "RM") {
    return (
      <Routes>
        <Route
          path="*"
          element={<Navigate to="/RMDashboard/PartnerManagement" replace />}
        />
        {RMRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    );
  } else if (idToken && loggedInRoleType === "PAYOUT_MAKER") {
    return (
      <Routes>
        <Route
          path="*"
          element={<Navigate to="/PayoutMakerDashBoard/PartnerPayout/generate-report" replace />}
        />
        {PayoutMakerRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    );
  } else if (idToken && loggedInRoleType === "PAYOUT_CHECKER") {
    return (
      <Routes>
        <Route
          path="*"
          element={<Navigate to="/PayoutCheckerDashBoard/PartnerPayout/payout-report" replace />}
        />
        {PayoutCheckerRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    );
  }else if (idToken && loggedInRoleType === "CP_CHECKER") {
    return (
      <Routes>
        <Route
          path="*"
          element={<Navigate to="/PayoutCPCheckerDashBoard/PartnerPayout/payout-report" replace />}
        />
        {PayoutCPCheckerRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    );
  } else if (idToken && (loggedInRoleType === "PARTNER" || loggedInRoleType === "PLMU")) {
    return (
      <Routes>
        <Route
          path="*"
          element={
            <Navigate
              to={
                verificationStatus
                  ? "/leadManagementDashboard/leadManagement"
                  : "/leadManagementDashboard/Dashboard"
              }
              replace
            />
          }
        />
        {PartnerRoutes?.filter((r) => r.active)?.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    );
  } else if (idToken && loggedInRoleType === "POU") {
    return (
      <Routes>
        <Route
          path="*"
          element={
            <Navigate
              to={
                verificationStatus
                  ? "/leadManagementDashboard/Dashboard"
                  : "/leadManagementDashboard/Dashboard"
              }
              replace
            />
          }
        />
        {PartnerRoutes?.filter((r) => r.active)?.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    );
  } else {
    return (
      <Routes>
        <Route path="*" element={<Navigate to="/signin" replace />} />
        <Route path="/" element={<Login />} />
        <Route path="signin" element={<Login />} />
        {/* <Route path="signin2" element={<Login2 />} /> */}

        {/* 
        <Route path="CETDashboard/*" element={<CETDashboardContainers />} />
        <Route
          path="PartnerDashBoard/*"
          element={<PartnerDashBoardContainers />}
        /> */}
      </Routes>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    state,
    checkLogin: state?.auth?.checkLogin,
    partnerSidebarDtoList: state.partnerSidebar?.partnerSidebarDtoList,
    partnerFirmDetails:
      state?.auth?.partnerFirmDetails ||
      state?.auth?.checkLogin?.partnerFirmDetails,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
    access_token: state?.auth?.idToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPartnerSidebar: (data) => dispatch(getPartnerSidebar(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RestrictedRoutes);
